/**
 * Tutte le stringhe dell'interfaccia. Tono del brand book: tu, frasi brevi, verbi d'azione,
 * numeri esatti, sempre il passo successivo. Mai "Clicca qui".
 */
export const comuni = {
  app: 'Aulaviva',
  caricamento: 'Un momento',
  esci: 'Esci',
  temaChiaro: 'Passa al tema chiaro',
  temaScuro: 'Passa al tema scuro',
  erroreRete: 'Non riusciamo a raggiungere Aulaviva. Controlla la connessione e riprova.',
  erroreGenerico: 'Qualcosa non ha funzionato. Riprova tra qualche secondo.',
  riprova: 'Riprova',
  vaiAlContenuto: 'Vai al contenuto',
  menuPrincipale: 'Menu principale',
};

export const nav = {
  percorso: 'Il mio percorso',
  attestati: 'I miei attestati',
  profilo: 'Profilo',
};

export * from './percorsi';
export * from './gestione';
export * from './admin';
export * from './aula';
export * from './presenze';
export * from './test';
export * from './documenti';
export * from './amministrazione';
export * from './sicurezza';
export * from './manuale';

export const auth = {
  campi: {
    email: 'Email',
    password: 'Password',
    nuovaPassword: 'Scegli una password',
    aiutoPassword: 'Almeno 10 caratteri. Meglio una frase che ricordi facilmente.',
    nome: 'Nome',
    cognome: 'Cognome',
    codiceFiscale: 'Codice fiscale',
    ordine: 'Ordine o associazione',
    aiutoOrdine: 'Per esempio: ODCEC Bologna.',
    numeroAlbo: "Numero di iscrizione all'albo",
    aiutoNumeroAlbo: 'Facoltativo. Serve per i crediti formativi.',
    codice: 'Codice ricevuto via email',
    aiutoCodice: 'Sono 6 cifre e valgono 10 minuti.',
  },
  accedi: {
    titolo: 'Entra in Aulaviva',
    sottotitolo: 'Usa l’email con cui ti sei iscritto.',
    azione: 'Accedi',
    inCorso: 'Accesso in corso',
    nonHaiAccount: 'Non hai ancora un account?',
    registrati: 'Iscriviti',
    emailNonVerificata: 'La tua email non è ancora verificata: ti abbiamo inviato un nuovo codice.',
    credenzialiErrate: 'Email o password non corrispondono. Controlla e riprova.',
  },
  registrati: {
    titolo: 'Iscriviti ad Aulaviva',
    sottotitolo: 'Servono il codice fiscale e un’email che leggi davvero: lì arrivano codici, inviti e attestati.',
    azione: 'Iscriviti',
    inCorso: 'Invio in corso',
    haiAccount: 'Hai già un account?',
    accedi: 'Accedi',
    privacy: 'Il codice fiscale è cifrato e lo vedono solo gli amministratori e il report per l’Ordine.',
  },
  verificaEmail: {
    titolo: 'Controlla la posta',
    sottotitolo: (email: string) => `Abbiamo inviato un codice a ${email}. Inseriscilo qui e scegli la password.`,
    azione: 'Conferma e scegli la password',
    inCorso: 'Verifica in corso',
    rinvia: 'Rinvia il codice',
    rinviato: 'Codice inviato: controlla la posta, anche nello spam.',
    emailMancante: 'Non sappiamo a quale email inviare il codice.',
    tornaAllaRegistrazione: 'Torna all’iscrizione',
    codiceErrato: 'Il codice non corrisponde o è scaduto. Controlla l’ultima email o richiedine uno nuovo.',
  },
  nuovoDispositivo: {
    titolo: 'Nuovo dispositivo',
    sottotitolo: (email: string) =>
      `Non conosciamo ancora questo dispositivo. Abbiamo inviato un codice a ${email}: inseriscilo per continuare.`,
    azione: 'Conferma il dispositivo',
    inCorso: 'Verifica in corso',
    rinvia: 'Rinvia il codice',
    rinviato: 'Codice inviato: controlla la posta, anche nello spam.',
    tornaAllAccesso: 'Torna all’accesso',
  },
};

export const profilo = {
  titolo: 'Profilo',
  sottotitolo: 'I tuoi dati come li vede l’organizzatore. Per correggerli, scrivi all’assistenza.',
  nome: 'Nome',
  cognome: 'Cognome',
  email: 'Email',
  codiceFiscale: 'Codice fiscale',
  ordine: 'Ordine o associazione',
  numeroAlbo: 'Numero di iscrizione all’albo',
  ruolo: 'Ruolo',
  ruoli: { partecipante: 'Partecipante', relatore: 'Relatore', regia: 'Regia', admin: 'Amministratore' } as const,
  nonIndicato: 'Non indicato',
};

export const nonTrovata = {
  titolo: 'Questa pagina non esiste',
  testo: 'L’indirizzo potrebbe essere cambiato o contenere un errore.',
  azione: 'Vai al mio percorso',
};
